/** Existing public route for a linked MapTODO place (`event.locationId` wire field unchanged). */
export function eventPlacePath(event) {
  const locationId = String(event?.locationId || '').trim();
  if (!locationId) return '';
  return `/places/${encodeURIComponent(locationId)}`;
}
